import { useTranslation } from 'react-i18next';
import './style.css';
import { Block, CRIcon } from '@/components/crRender';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useMemo } from 'react';

const QuotationSummary = ({ admissionDetails }) => {
    const { t } = useTranslation();

    const packages = useMemo(() => admissionDetails?.requestData?.packages || [], [admissionDetails?.requestData?.packages]);
    const addOns = useMemo(() => admissionDetails?.requestData?.addOns || [], [admissionDetails?.requestData?.addOns]);
    const postServices = useMemo(() => admissionDetails?.requestData?.postServices || [], [admissionDetails?.requestData?.postServices]);


    const isSelectAddon = useMemo(() => addOns.some(addon => addon.isSelected), [addOns]);
    const isSelectPostService = useMemo(() => postServices.some(service => service.isSelected), [postServices]);

    return (
        <div className="quotation-summary-section">

            <h2 className="quotation-summary-title">
                <Icon icon="tdesign:money-filled" width="20" height="20" /> {" "}
                {t('quotation-summary')}
            </h2>

            <div className="quotation-summary-cards">

                <div className="quotation-summary-card">
                    <div className="quotation-summary-label">{t('expected-length-of-stay')}</div>
                    <div className="quotation-summary-value">
                        <Icon icon="icon-park-outline:homestay" width="1.2em" height="1.2em" style={{ marginRight: '0.25rem' }} />
                        {admissionDetails?.requestData?.expectedLengthOfStay || '2 - 3'} {t('days')}
                    </div>
                </div>
            </div>


            <div className="quotation-summary-cards-container">
                <Block isRender={!packages.isEmpty()} className="quotation-summary-card package-card">
                    <div className="quotation-summary-label">{t('included-in-your-package')}</div>

                    <div className="quotation-summary-package-list">
                        {packages?.map((item, index) => (
                            <div key={index} className="quotation-summary-package-item">
                                <span className="quotation-summary-package-name"> <Icon className="quotation-summary-package-name-icon" icon="mdi:package-variant" width="16" height="16" /> {item?.toUpperCase()}</span>
                                <span className="quotation-summary-package-name quotation-summary-package-price">$ {"0.00"}</span>
                            </div>
                        ))}
                    </div>
                </Block>
                {/* Included in Your Package */}
                <Block isRender={!addOns.isEmpty()} className="quotation-summary-card add-ons-card">
                    <div className="quotation-summary-label">
                        <span className="quotation-summary-label-text">{t('add-ons-extras')}</span>
                        <span className={`quotation-summary-label-user-selected ${isSelectAddon ? 'user-selected' : 'user-not-selected'}`}>
                            {isSelectAddon ? t('user-selected') : t('user-not-selected')}
                        </span>
                    </div>

                    <div className="quotation-summary-package-list">
                        {addOns?.map((item, index) => (
                            <div key={index} className="quotation-summary-package-item">
                                <span className={`quotation-summary-package-name ${isSelectAddon && !item.isSelected ? 'not-selected' : ''}`}>
                                    <CRIcon isRender={isSelectAddon && item.isSelected} className="quotation-summary-package-name-icon" icon="mdi:plus-circle-outline" width="20" height="20" /> {item?.name?.toUpperCase()}
                                    <CRIcon isRender={!isSelectAddon} className="quotation-summary-package-name-icon" icon="simple-line-icons:exclamation" width="20" height="20" /> {item?.name?.toUpperCase()}
                                    <CRIcon isRender={!isSelectAddon && !item.isSelected} className="quotation-summary-package-name-icon" icon="line-md:cancel" width="20" height="20" /> {item?.name?.toUpperCase()}
                                </span>
                                <span className={`quotation-summary-package-name quotation-summary-package-price ${isSelectAddon && !item.isSelected ? 'not-selected' : ''}`}>$ {item?.price?.toFixed(2)}</span>
                            </div>
                        ))}
                    </div>
                </Block>
                {/* Included in Your Package */}
                <Block isRender={!postServices.isEmpty()} className="quotation-summary-card add-ons-card">
                    <div className="quotation-summary-label">
                        <span className="quotation-summary-label-text">{t('post-service-entry')}</span>
                        <span className={`quotation-summary-label-user-selected ${isSelectPostService ? 'user-selected' : 'user-not-selected'}`}>
                            {isSelectPostService ? t('user-selected') : t('user-not-selected')}
                        </span>
                    </div>

                    <div className="quotation-summary-package-list">
                        {postServices?.map((item, index) => (
                            <div key={index} className="quotation-summary-package-item">
                                <span className={`quotation-summary-package-name ${isSelectPostService && !item.isSelected ? 'not-selected' : ''}`}> <Icon className="quotation-summary-package-name-icon" icon="mdi:clock-outline" width="16" height="16" /> {item?.name?.toUpperCase()}</span>
                                <span className={`quotation-summary-package-name quotation-summary-package-price ${isSelectPostService && !item.isSelected ? 'not-selected' : ''}`}>$ {item?.price?.toFixed(2)}</span>
                            </div>
                        ))}
                    </div>
                </Block>
            </div>

            {/* Total */}
            <div className="quotation-summary-total-section">
                <Block isRender={!!admissionDetails?.requestData?.addsOnPrice} className="quotation-summary-total-row">
                    <span className="quotation-summary-total-label">{t('add-ons-extras')}</span>
                    <span className="quotation-summary-total-value quotation-summary-total-value-paid">$ {admissionDetails?.requestData?.addsOnPrice?.toFixed(2)}</span>
                </Block>
                <Block isRender={!!admissionDetails?.requestData?.postServicePrice} className="quotation-summary-total-row">
                    <span className="quotation-summary-total-label">{t('post-service-entry')}</span>
                    <span className="quotation-summary-total-value quotation-summary-total-value-paid">$ {admissionDetails?.requestData?.postServicePrice?.toFixed(2)}</span>
                </Block>
                <Block isRender={!!admissionDetails?.requestData?.price} className="quotation-summary-total-row">
                    <span className="quotation-summary-total-label">{t('base-quotation')}</span>
                    <span className="quotation-summary-total-value quotation-summary-total-value-paid">$ {admissionDetails?.requestData?.price?.toFixed(2)}</span>
                </Block>
                <Block isRender={!!admissionDetails?.requestData?.paidPrice} className="quotation-summary-total-row">
                    <span className="quotation-summary-total-label">{t('paid-price')}</span>
                    <span className="quotation-summary-total-value quotation-summary-total-value-paid">$ {admissionDetails?.requestData?.paidPrice?.toFixed(2)}</span>
                </Block>
                <Block isRender={!!admissionDetails?.requestData?.pendingPaymentAmount} className="quotation-summary-total-row">
                    <span className="quotation-summary-total-label">{t('pending-payment-amount')}</span>
                    <span className="quotation-summary-total-value quotation-summary-total-value-pending">$ {admissionDetails?.requestData?.pendingPaymentAmount?.toFixed(2)}</span>
                </Block>
                <Block isRender={!!admissionDetails?.requestData?.totalPrice} className="quotation-summary-total-row">
                    <span className="quotation-summary-total-label">{t('total-cost')}</span>
                    <span className="quotation-summary-total-value">$ {admissionDetails?.requestData?.totalPrice?.toFixed(2)}</span>
                </Block>
            </div>
        </div>
    );
};

export default QuotationSummary;
